import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAdmin } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-114, AC-2: инвалидирует ['admin','admins'] после успешного создания.
export function useCreateAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ login, password }: { login: string; password: string }) =>
      createAdmin(login, password),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
